module.exports = __webpack_public_path__ + "img/a_2.9220b75d.png";